export default __webpack_public_path__ + "static/media/image4pro2.0c354b58.jpeg";